import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { fmt } from '../../lib/formatters.js';

const METRICS = {
  costUsd: { label: 'Costo', axis: (v) => `$${v}`, format: (v) => fmt.usdFine(v) },
  calls: { label: 'Chiamate', axis: (v) => fmt.int(v), format: (v) => fmt.int(v) },
  totalTokens: { label: 'Token', axis: (v) => (v >= 1000 ? `${Math.round(v / 1000)}k` : `${v}`), format: (v) => fmt.int(v) }
};

function TooltipBox({ active, payload, label }) {
  if (!active || !payload || !payload.length) return null;
  const row = payload[0].payload;
  return (
    <div className="rounded-md border border-border bg-surface-elevated px-3 py-2 text-xs shadow-card">
      <p className="font-medium text-ink">{fmt.date(label)}</p>
      {row.costUsd != null && <p className="text-ink-muted">Costo: <span className="text-ink">{fmt.usdFine(row.costUsd)}</span></p>}
      {row.calls != null && <p className="text-ink-muted">Chiamate: <span className="text-ink">{fmt.int(row.calls)}</span></p>}
      {row.totalTokens != null && <p className="text-ink-muted">Token: <span className="text-ink">{fmt.int(row.totalTokens)}</span></p>}
    </div>
  );
}

export function CostTrendChart({ data = [], metric = 'costUsd' }) {
  const cfg = METRICS[metric] || METRICS.costUsd;

  if (!data.length) {
    return (
      <div className="flex h-64 items-center justify-center text-sm text-ink-muted">
        Nessun dato per il periodo selezionato.
      </div>
    );
  }
  return (
    <div className="h-64 w-full">
      <ResponsiveContainer>
        <AreaChart data={data} margin={{ top: 10, right: 12, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="trendGrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="var(--color-brand)" stopOpacity={0.35} />
              <stop offset="100%" stopColor="var(--color-brand)" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" vertical={false} />
          <XAxis
            dataKey="date"
            tickFormatter={(v) => fmt.shortDate(v)}
            tickLine={false}
            axisLine={false}
            stroke="var(--color-ink-muted)"
            fontSize={11}
          />
          <YAxis
            tickFormatter={cfg.axis}
            tickLine={false}
            axisLine={false}
            stroke="var(--color-ink-muted)"
            fontSize={11}
            width={48}
          />
          <Tooltip content={<TooltipBox />} cursor={{ stroke: 'var(--color-border-strong)' }} />
          <Area
            type="monotone"
            dataKey={metric}
            stroke="var(--color-brand)"
            strokeWidth={2}
            fill="url(#trendGrad)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
